import React from 'react';
export const Problem = () => {
  return <section className="py-6 sm:py-8" data-id="element-185">
      <h2 className="text-2xl font-bold text-[#E55A88] mb-5" data-id="element-186">
        The Problem Nobody's Talking About
      </h2>
      <div className="prose max-w-none text-base" data-id="element-187">
        <p data-id="element-188">
          Here's what Margaret didn't know:{' '}
          <strong data-id="element-189">
            76% of menopausal women feel completely ignored by the healthcare
            system.
          </strong>
        </p>
        <p data-id="element-190">Meanwhile, you're dealing with:</p>
        <div className="bg-[#FFF4F7] p-4 rounded-md my-5" data-id="element-191">
          <p className="mb-3 text-sm sm:text-base flex items-start" data-id="element-192">
            <span className="text-[#E55A88] mr-2" data-id="element-193">✗</span>
            <span data-id="element-194">Hot flashes that make you miserable</span>
          </p>
          <p className="mb-3 text-sm sm:text-base flex items-start" data-id="element-195">
            <span className="text-[#E55A88] mr-2" data-id="element-196">✗</span>
            <span data-id="element-197">Stubborn weight gain around your middle</span>
          </p>
          <p className="mb-3 text-sm sm:text-base flex items-start" data-id="element-198">
            <span className="text-[#E55A88] mr-2" data-id="element-199">✗</span>
            <span data-id="element-200">Mood swings that make you feel crazy</span>
          </p>
          <p className="mb-3 text-sm sm:text-base flex items-start" data-id="element-201">
            <span className="text-[#E55A88] mr-2" data-id="element-202">✗</span>
            <span data-id="element-203">Brain fog that affects your work</span>
          </p>
          <p className="mb-3 text-sm sm:text-base flex items-start" data-id="element-204">
            <span className="text-[#E55A88] mr-2" data-id="element-205">✗</span>
            <span data-id="element-206">Night sweats that destroy your sleep</span>
          </p>
          <p className="mb-0 text-sm sm:text-base flex items-start" data-id="element-207">
            <span className="text-[#E55A88] mr-2" data-id="element-208">✗</span>
            <span data-id="element-209">Energy crashes that steal your life</span>
          </p>
        </div>
        <p data-id="element-210">
          And when you ask for help, you're told to "manage stress" or "try
          hormone therapy" (with all its risks).
        </p>
        <p data-id="element-211">But what if ALL these symptoms have ONE underlying cause?</p>
      </div>
    </section>;
};